import React, { useEffect, useMemo, useState } from 'react';
import PollVoteCardView from "./poll-vote-card.view";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import server from "../../../server";
import Locale from "../../../core/locale/locale";
import { Poll, Vote } from "../../../domains/models/poll";


const PollVoteCard = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [data, setData] = useState<(Poll|Vote)[]>([]);

    useEffect(() => {
        //fetch latest created active poll/vote for 1 months in advance
        fetchPollVote();
    }, [])

    function navigateToPollsVote() {
        navigate('/poll')
    }

    async function fetchPollVote() {
        setIsLoading(true);
        const startDate = dayjs().startOf('month').format(Locale.dateFormat);
        const endDate = dayjs().add(1, 'month').endOf('month').format(Locale.dateFormat);
        const payload={
            start: {startDate: startDate, endDate: endDate},
            active: true,
            sortDirection:'DESC'
        }
        const res = await server.poll.search(payload);
        setData(res);
        setIsLoading(false);
    }

    async function submitResponse(id:string) {
       await server.poll.vote(id);
        await fetchPollVote();
    }

    const activePolls = useMemo(() => {
        return data.filter((vote:Poll|Vote)=>!vote.hasVoted);
    }, [data]);


    return (
        <PollVoteCardView
            data={activePolls}
            isLoading={isLoading}
            navigateToPollsVote={navigateToPollsVote}
            submitResponse={submitResponse}
        />
    )
}

export default PollVoteCard;
